<template>
    <AppSeoTags>
        <title>Steve Says</title>
        <link head-key="canonical" rel="canonical" :href="currentUrl">
        <meta head-key="description"
              name="description"
              content="Former motor racing driver and journalist Steve Sutcliffe has worked with Tyre Seeker to review and identify the very best tyres of 2022">
    </AppSeoTags>
    <AppJumbotron class="relative">
        <h1 class="text-3xl lg:text-4xl xl:text-5xl tracking-wide text-white max-w-[500px]">Steve Says</h1>
        <p class="text-white mt-4 max-w-[550px] mb-8">Steve Sutcliffe, motoring journalist, racing driver, all round car guru and Tyre Seekers resident tyre tester reviews the latest and greatest from the major tyre manufacturers to let you know what is best to go on your car next time you need to change...</p>
        <div class="absolute bottom-0 left-1/2 transform hidden lg:block">
            <img src="/images/steves-reviews.png" alt="Steve Says" />
        </div>
    </AppJumbotron>

    <div v-if="latestArticle" class="bg-grey-100 py-4">
        <AppContainer>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center gap-8">
                <div>
                    <span class="bg-red rounded-full text-dark py-2 px-4 font-bold">
                        <FontAwesomeIcon :icon="['fab', 'youtube']"></FontAwesomeIcon>
                        Latest Video
                    </span>

                    <h2 class="text-3xl text-dark mt-4 font-bold">{{ latestArticle.title }}</h2>

                    <p class="mt-4">{{ latestArticle.excerpt ?? latestArticle.excerpt_from_description }}</p>

                    <AppButton class="mt-4" theme="secondary" :href="route('steves-reviews.show', latestArticle.slug)">
                        View Article
                    </AppButton>
                </div>

                <div class="col-span-1 lg:col-span-2">
                    <AppVideo :type="latestArticle.videos[0].type" :clip="latestArticle.videos[0].video_id"></AppVideo>
                </div>
            </div>
        </AppContainer>
    </div>

    <AppContainer>
        <h3 class="text-dark text-bold text-3xl my-8">Steve's Latest Reviews</h3>
        <div v-if="posts.data.length">
            <MasonryWall class="my-8" :items="posts.data" :columns="3" :gap="16" v-slot="slotProps">
                <NewsArticleCard
                    :key="slotProps.index"
                    :title="slotProps.item.title"
                    :excerpt="slotProps.item.excerpt ?? slotProps.item.excerpt_from_description"
                    :video="slotProps.item?.videos?.[0]"
                    :image="slotProps.item.image"
                    :link="route('steves-reviews.show', slotProps.item.slug)"
                    :date="slotProps.item.created_at"
                ></NewsArticleCard>
            </MasonryWall>
            <AppPagination class="justify-center" :links="posts.links"></AppPagination>
        </div>
        <div v-else>
            <div class="bg-red text-white p-4">
                <p class="text-center font-bold">No Reviews at this time</p>
            </div>
        </div>
    </AppContainer>
</template>

<script>
import AppHead from "@/Components/AppSeoTags";
import AppSeoTags from "@/Components/AppSeoTags";
import AppVideo from "@/Components/AppVideo";
import AppButton from "@/Components/AppButton";
import {useCurrentPath} from "@/Composables/useCurrentPath";
import AppJumbotron from "@/Components/AppJumbotron";
import AppContainer from "@/Layouts/AppContainer";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import MasonryWall from "@/Components/MasonryWall";
import NewsArticleCard from "@/Components/Articles/ArticleCard";
import AppPagination from "@/Components/AppPagination";

export default {
    name: "ViewAllReviewPosts",
    components: {
        AppHead,
        AppPagination,
        AppButton,
        AppVideo,
        MasonryWall,
        AppContainer,
        AppJumbotron,
        AppSeoTags,
        FontAwesomeIcon,
        NewsArticleCard
    },
    props: {
        posts: Object,
        latestArticle: Object
    },
    data()
    {
        return {
            currentUrl : useCurrentPath()
        }
    }
}
</script>

<style scoped>

</style>
